export default {
    "PROGRAM": {
        "PROGRAM": "Program",
        "NAME": "Name",
        "NAME_EN": "English name",
        "START": "Start",
        "END": "End",
        "LOCATION": "Location",
        "ARTIST": "Artist",
        "DESCRIPTION": "Description",
        "LONG_DESCRIPTION": "Long description",
        "FILE": "File",
        "STATUS": "Status",
        "SLUG": "URL",
        "IS_CHANGED": "Changed",
        "CLONE": "Clone Program",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/program.js